import './index.scss';
import GaugeSquare from './GaugeSquare';
import { useEffect, useState } from 'react';
import { getSingleOption } from '../../../../utility/Utils';
import getLoadGaugeRows from '../../../../utility/functions/get-load-gauge-rows';
import { useResourceManagementSlots } from '../../../../store/RoomManagement/resourceManagementHooks';

interface props {
  start: string;
  end: string;
  openFrom: number;
  openTo: number;
  date: string[];
  minBookingTime: number;
}

const LoadGauge = ({
  start,
  end,
  date,
  minBookingTime,
  openFrom,
  openTo,
}: props) => {
  const slotsArray = useResourceManagementSlots();

  const [rows, setRows] = useState<number[][]>([]);

  useEffect(() => {
    const slots = [...slotsArray];

    setRows(
      getLoadGaugeRows(
        slots,
        minBookingTime,
        openFrom,
        openTo,
        date,
        start,
        end
      )
    );
  }, [start, end, slotsArray, openFrom, openTo]);

  const times = ['00:00', '06:00', '12:00', '18:00', '24:00'];

  const getTitleFromIndex = (index: number) => {
    const hour = index * 0.5;
    return getSingleOption(hour).label;
  };

  return (
    <>
      <div className="gauge-squares-container">
        {rows.map((row, index) => {
          return (
            <GaugeSquare
              title={getTitleFromIndex(index)}
              firstHalfColor={row[0]}
              secondHalfColor={row[1]}
              key={index}
            />
          );
        })}
      </div>
      <div className="gauge-squares-times">
        {times.map((time) => (
          <div className="gauge-squares-time" key={time.toString()}>
            <span>{time}</span>
          </div>
        ))}
      </div>
    </>
  );
};

export default LoadGauge;
